import React, { Component } from "react";
import { connect } from "react-redux";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import CommentTransactionLayout from "../components/CommentTransactionLayout";
import * as actions from "../redux/actions/transactionAcceptedActions";

class CommentTransactionAccepted extends Component {
  componentDidMount() {
    this.fetchCommentList();
  }

  fetchCommentList = async () => {
    try {
      await this.props
        .LoadTransactionAccepted(
          this.props.ad.UserStore.Id,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <CommentTransactionLayout
        variant="accepted"
        loading={this.props.loading}
        commentList={this.props.commentList}
        adId={this.props.ad?.Id}
      />
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,
    error: reducer.transactionAccepted.error,
    loading: reducer.transactionAccepted.loading,
    commentList: reducer.transactionAccepted.list,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadTransactionAccepted: (id, user_id, token) =>
    dispatch(actions.loadList({ id, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentTransactionAccepted);
